export default __webpack_public_path__ + "static/media/privileg.4b91c9df.svg";